<template>
    <div id="body" class="fadein">
    <!-- style样式引入 -->
    <link rel="stylesheet" href="./static/css/login.css" />
    <!-- 登录窗口 start -->
    <div class="login-box">
        <h2><img src="/static/img/Lighting_s.png" alt=""></h2>
        <h2>登录</h2>
        <form @keyup.enter="login()">
            <div class="user-box">
            <input type="text" name="username" required="" v-model="username" />
            <label>用户名</label>
            </div>
            <div class="user-box">
            <input type="password" name="password" required="" v-model="password"/>
            <label>密码</label>
            </div>
            <a href="javascript:;" class="lighting" @click="login()">
            <span></span>
            <span></span>
            <span></span>
            <span></span>
            Lighting
            </a><br>
            <!-- test -->
            <!-- <el-button size="small" @click="logout()">登出</el-button> -->
            <div class="reg">
                <router-link to="/forget">忘记密码</router-link>
                <span style="display: inline-block;width:10px;"></span>
                <router-link to="/register">注册</router-link>
                <span style="display: inline-block;width:10px;"></span>
                <router-link to="/index">返回主页</router-link>
                <br>
                <br>
                <!-- <a href="//'+ this.$API_URL +'/api/v1/login/alipay_login"><img src="/static/icon/pay.png" alt=""></a>  -->
                <!-- <a href="javascript:;" @click="getAli"><img src="/static/icon/pay.png" alt=""></a> 
                <a href=""><img src="/static/icon/qq.png" alt=""></a> 
                <a href=""><img src="/static/icon/weixin.png" alt=""></a>  -->
            </div>
        </form>
      </div>
    </div>
    <!-- 登录窗口 end -->
</template>

<script>
    export default{
        data(){
            return {
                // username:'13376087379',
                // password:'123123',
                username:'',
                password:'',
                oldroute:'',
            }
        },

        methods:{
            login(){
                if(this.username.length<5 || this.password.length<5){
                    this.$message({
                        showClose:true,
                        message:'用户名或密码错误 :<',
                        type:'error'
                    })
                    return false;
                }
                
                $.ajax({
                    // url:'//'+ this.$API_URL +'/api/v1/login',
                    url:'//'+ this.$API_URL +'/api/v1/login',
                    data:{username:this.username,password:this.password},
                    type:'POST',
                    timeout:3000,
                    success:ret=>{
                        
                        
                        if(ret.code==200){
                            this.$message({
                                showClose: true,
                                message: '登录成功 :)',
                                type: 'success'
                            });
                            // 
                            localStorage.setItem("token",ret.data[0].id);
                            // this.$router.push('index');
                            this.$router.go(-1);
                            // console.log(this.oldroute)
                            // this.$router.push(this.oldroute).catch(err => {err});

                        }else{
                            this.$message({
                                showClose: true,
                                message: '用户名或密码错误 :<',
                                type: 'error'
                            });
                        }
                    },
                    error:ret=>{
  
                        
                        
                    },
                })

            },

            //第三方登录
            async getAli(){
                  const { data: res } = await this.$http.get("/login/alipay_login");
                console.log(res)
                //       if (res.meta.status !== 200) {
                //         return this.$toast.fail("数据加载失败");
                //       }
                //       this.swipeList = res.message;

                // $.ajax({
                //     url:"//'+ this.$API_URL +'/api/v1/login/alipay_login",
                //     type:"get",
                //     success:(ret)=>{
                //         console.log(ret);
                //     }
                // })
            }
        }
    }
</script>
<style scoped>
#body {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// src/components/login/login.vue